/* Om Flower Spring Sale free gift auto-add.
   Adds the configured gift product to the cart (with a hidden _free_gift line
   property) whenever the cart holds a qualifying paid item, and removes it when
   the cart no longer qualifies. Pair with a Buy X Get Y automatic discount so
   the gift rings up at $0 at checkout. */
(function () {
  var dataEl = document.getElementById('om-free-gift-data');
  if (!dataEl) return;
  var cfg;
  try {
    cfg = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var busy = false;
  var pending = false;
  var didNudge = false;
  var OPTOUT_KEY = 'om_gift_optout';
  var HADGIFT_KEY = 'om_gift_present';

  function isGift(item) {
    return item.properties && item.properties._free_gift;
  }

  function refreshUi() {
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') drawerItems.onCartUpdate();
    var cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.tagName !== 'CART-DRAWER-ITEMS' && typeof cartItems.onCartUpdate === 'function') {
      cartItems.onCartUpdate();
    }
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    /* Cart-page footer is its own section; refresh it (the drawer footer
       has no shopify-section wrapper). */
    document.querySelectorAll('#main-cart-footer').forEach(function (tot) {
      var sec = tot.closest('.shopify-section');
      if (!sec || sec.id.indexOf('shopify-section-') !== 0) return;
      var sid = sec.id.slice('shopify-section-'.length);
      fetch(cartUrl + '?section_id=' + encodeURIComponent(sid))
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var html = new DOMParser().parseFromString(t, 'text/html');
          var src = html.querySelector('.shopify-section') || html.body;
          sec.innerHTML = src.innerHTML;
        })
        .catch(function () {});
    });
    fetch(cartUrl + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var html = new DOMParser().parseFromString(t, 'text/html');
        var src = html.querySelector('.shopify-section') || html.body;
        var tgt = document.getElementById('cart-icon-bubble');
        if (src && tgt) tgt.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function sync() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLines = cart.items.filter(isGift);
        var others = cart.items.filter(function (i) { return !isGift(i); });
        var subtotal = others.reduce(function (s, i) { return s + i.original_line_price; }, 0);
        var qualifies = others.length > 0 && subtotal >= (cfg.minSpend || 0);
        var hadGift = sessionStorage.getItem(HADGIFT_KEY) === '1';
        var optedOut = sessionStorage.getItem(OPTOUT_KEY) === '1';

        if (others.length === 0) sessionStorage.removeItem(OPTOUT_KEY);

        if (qualifies && giftLines.length === 0 && hadGift && !optedOut) {
          /* Gift vanished while the cart still qualifies: the customer removed
             it on purpose. Respect that for the rest of the session. */
          sessionStorage.setItem(OPTOUT_KEY, '1');
          optedOut = true;
        }
        sessionStorage.setItem(HADGIFT_KEY, giftLines.length > 0 ? '1' : '0');

        if (qualifies && giftLines.length === 0 && !optedOut) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: cfg.variantId,
              quantity: 1,
              properties: { _free_gift: 'spring-sale' }
            })
          }).then(function (r) {
            if (r.ok) {
              sessionStorage.setItem(HADGIFT_KEY, '1');
              refreshUi();
            }
          });
        }
        if (qualifies && giftLines.length > 0 && giftLines[0].final_line_price > 0 && !didNudge) {
          /* Carts created before the discount went live can hold stale pricing
             until the next mutation. A same-quantity change forces Shopify to
             re-evaluate automatic discounts. One attempt per page load. */
          var covered = cart.items.some(function (i) {
            return !isGift(i) && i.variant_id === giftLines[0].variant_id && (i.discounts || []).some(function (d) { return d.amount > 0; });
          });
          if (!covered) {
            didNudge = true;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: giftLines[0].key, quantity: giftLines[0].quantity })
            }).then(function (r) { return r.json(); }).then(function (c2) {
              var g2 = (c2.items || []).filter(isGift);
              if (g2.length && g2[0].final_line_price === 0) refreshUi();
            });
          }
        }
        if (!qualifies && giftLines.length > 0) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: giftLines[0].key, quantity: 0 })
          }).then(function (r) {
            if (r.ok) {
              sessionStorage.setItem(HADGIFT_KEY, '0');
              refreshUi();
            }
          });
        }
      })
      .catch(function (e) {
        console.error('[om-free-gift]', e);
      })
      .then(function () {
        busy = false;
        if (pending) {
          pending = false;
          setTimeout(sync, 400);
        }
      });
  }

  var debounceTimer;
  function queueSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 250);
  }

  /* Watch every cart mutation, whichever code path fires it. */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(queueSync).catch(function () {});
    }
    return p;
  };

  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, queueSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
